export class Lang {
  constructor(
    public Name: string,
    public Code: string,
    public Icon: string = 'fa fa-globe',
  ) { }
}
